// import React, { useEffect, useState } from "react";
// import Layout from "../Layout/Layout";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import Table from "react-bootstrap/Table";
// import ItemService from "../services/supplier_appCommonService";

// const SentEmail = () => {
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     getData();
//   }, []);

//   const getData = async () => {
//     const response = await ItemService.getCustomNotification();

//     if (response?.status === 200) {
//       setData(response.data || []);
//     }
//   };

//   return (
//     <main className="dashboard main"  id="main">
//       <Layout />

//       <Row className="subContent">
//         <Col xs={12}>
//           <div className="rightSideInner">

//             <h2 className="mainTitle">
//               Sent Emails
//             </h2>

//             <Table striped bordered hover responsive>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Recipient</th>
//                   <th>Subject</th>
//                   <th>Message</th>
//                   <th>Status</th>
//                   <th>Sent On</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {data.length > 0 ? (
//                   data.map((item, index) => (
//                     <tr key={item._id}>
//                       <td>{index + 1}</td>
//                       <td>{item.emailId}</td>
//                       <td>{item.subject}</td>

//                       <td>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: item.message,
//                           }}
//                         />
//                       </td>

//                       <td>
//                         <span className="badge bg-success">
//                           {item.status}
//                         </span>
//                       </td>

//                       <td>
//                         {new Date(item.createdAt).toLocaleString()}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan={6}
//                       className="text-center"
//                     >
//                       No Emails Found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>

//           </div>
//         </Col>
//       </Row>
//     </main>
//   );
// };

// export default SentEmail;

import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import ItemService from "../services/supplier_appCommonService";
import SupplierConstants from "../common/SupplierConstants";

const SentEmail = () => {
  localStorage.setItem("menu", "Contract");
  localStorage.setItem("submenu", "Sent Email");

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    try {
      const response = await ItemService.getCustomNotification();

      if (response?.status === 200) {
        setData(response.data || []);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="subContent">
        <Col xs={12} className="rightSide">
          <div className="rightSideInner">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h2 className="mainTitle mb-1">Sent Emails</h2>
                <p className="text-muted mb-0">
                  List of all sent custom emails
                </p>
              </div>

              <button
                className="btn btn-primary"
                onClick={() => navigate(SupplierConstants.EMAIL_SENDER)}
              >
                <i className="bi bi-envelope-plus me-2"></i>
                Compose
              </button>
            </div>

            <div className="card shadow-sm">
              <div className="card-body">
                <Table striped bordered hover responsive>
                  <thead className="table-primary">
                    <tr>
                      <th style={{ width: "70px" }}>#</th>
                      <th>Recipient</th>
                      <th>Vendor</th>
                      <th>Subject</th>
                      <th>Status</th>
                      <th>Sent On</th>
                      <th style={{ width: "130px" }}>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={7} className="text-center p-4">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={item._id}>
                          <td>{index + 1}</td>

                          <td>{item.emailId}</td>

                          <td>{item.vendorName}</td>

                          <td>{item.subject}</td>

                          <td>
                            <span
                              className={`badge ${
                                item.status === "Unread"
                                  ? "bg-warning text-dark"
                                  : "bg-success"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>

                          <td>{new Date(item.createdAt).toLocaleString()}</td>

                          <td>
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() =>
                                navigate(SupplierConstants.EMAIL_DETAILS, {
                                  state: item,
                                })
                              }
                            >
                              <i className="bi bi-eye me-1"></i>
                              Details
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center text-muted">
                          No Sent Emails Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default SentEmail;
